<template>
    <div class="card col-12 p-0 ">
        <!-- <div class="card-header fs-6 fw-bold pt-2 pb-0 pl-3">
            <p class="m-0">Sentencing Rules</p>
        </div> -->
        <div class="card-body p-1 m-0 d-flex flex-column">
            <div class="col-12 d-flex flex-column p-4 fs-5" v-for="rule in ruleWords" :key="rule.Id">
                <h4 class=" fs-4">{{rule.Abbreviation}}</h4>
                <p v-html="rule.Text"></p>
                <p v-if="rule?.SectionNumber">{{rule?.SectionNumber}}</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'RuleWords',
    props: ['user_token', 'charge', 'selectedCase', 'ruleWords'],
    data() {
        return {

        }
    },
}
</script>